import React from 'react'
import "./navbar.css"
import useAuth from 'src/hooks/useAuth'
import { Link } from "react-router-dom"

const Navbar = () => {

    const { logout , user } = useAuth()

    return (
        <header className="container-fluid py-0" style={{ backgroundColor: "#322053" }}>
            <div className="d-flex justify-content-between">
                <div>
                    <Link to="/" className='text-decoration-none'>
                        <h3 className="text-white logo">Skills4Life</h3>
                    </Link>
                </div>
                <div>
                    <div className="text-white d-flex">
                        <div>
                            <span className='mx-2 border px-2 py-2'>{user?.full_name}</span>
                            <button onClick={logout} className='btn btn-danger my-3'>Logout</button>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Navbar